import { useSelector } from "../../../../hooks";
import { BusinessCharCard } from "./BussinessCharCard/BusinessCharCard";
import { BusinessCharType } from "../../../../redux/businesses";
import styles from "./BusinessChars.module.scss";
import areaIcon from "../icons/area.png";
import staffIcon from "../icons/staff.png";

export const BusinessChars = () => {
    const business = useSelector(store => store.businesses.activeBusiness);

    if (!business)
        return <></>;

    return (
        <div className={styles.charsWrapper}>
            <BusinessCharCard { ...business.area } type={ BusinessCharType.Area } icon={ areaIcon } />
            <BusinessCharCard { ...business.staff } type={ BusinessCharType.Staff } icon={ staffIcon } />
        </div>
    );
}